import {
  FormControl,
  FormErrorMessage,
  FormHelperText,
  FormLabel,
  Textarea,
  TextareaProps,
} from "@chakra-ui/react";
import React from "react";

type Props = TextareaProps & {
  helpText?: string;
  label: string;
  error?: {
    message?: string;
  };
};

export const TextAreaInput = React.forwardRef((props: Props, ref: any) => {
  const { helpText, label, error, name, ...rest } = props;
  return (
    <FormControl isInvalid={Boolean(error)}>
      <FormLabel htmlFor={name}>{label}</FormLabel>
      <Textarea
        id={name}
        ref={ref}
        name={name}
        borderColor={error ? "red.500" : undefined}
        {...rest}
      />
      <FormErrorMessage>{error?.message}</FormErrorMessage>
      {helpText && <FormHelperText>{helpText}</FormHelperText>}
    </FormControl>
  );
});
TextAreaInput.displayName = "TextAreaInput";

export default TextAreaInput;
